import React from 'react';

import { BaseIcon } from '@/shared/assets/icons/base-icon/base-icon';
import { TBaseIcon } from '@/shared/assets/icons/base-icon/base-icon.types';

export const MfaAppIcon: React.FC<TBaseIcon> = (props) => {
  return (
    <BaseIcon
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      {...props}
    >
      <path
        d="M14.9974 1.66406C15.2184 1.66406 15.4304 1.75186 15.5867 1.90814C15.7429 2.06442 15.8307 2.27638 15.8307 2.4974V8.33073H14.1641V3.33073H5.83073V16.6641H9.9974V18.3307H4.9974C4.77638 18.3307 4.56442 18.2429 4.40814 18.0867C4.25186 17.9304 4.16406 17.7184 4.16406 17.4974V2.4974C4.16406 2.27638 4.25186 2.06442 4.40814 1.90814C4.56442 1.75186 4.77638 1.66406 4.9974 1.66406H14.9974ZM14.9974 9.9974C15.6604 9.9974 16.2963 10.2608 16.7652 10.7296C17.234 11.1985 17.4974 11.8344 17.4974 12.4974V13.3307H18.3307V17.4974C18.3307 17.7184 18.2429 17.9304 18.0867 18.0867C17.9304 18.2429 17.7184 18.3307 17.4974 18.3307H12.4974C12.2764 18.3307 12.0644 18.2429 11.9081 18.0867C11.7519 17.9304 11.6641 17.7184 11.6641 17.4974V13.3307H12.4974V12.4974C12.4974 11.8344 12.7608 11.1985 13.2296 10.7296C13.6985 10.2608 14.3344 9.9974 14.9974 9.9974ZM16.6641 14.9974H13.3307V16.6641H16.6641V14.9974ZM14.9974 11.6641C14.5741 11.6641 14.1641 12.0391 14.1641 12.4974V13.3307H15.8307V12.4974C15.8307 12.2764 15.7429 12.0644 15.5867 11.9081C15.4304 11.7519 15.2184 11.6641 14.9974 11.6641Z"
        fill="currentColor"
      />
    </BaseIcon>
  );
};

MfaAppIcon.displayName = 'MfaAppIcon';
